import React from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';

import { LineWave } from 'react-loader-spinner';
import styles from './styles.module.scss';

const Button = ({
  children,
  className,
  isLoading,
  disabled,
  type = 'primary',
  ...otherProps
}) => {
  const loaderColors = {
    primary: '#fff',
    outline: '#841474',
  };

  const loader = (
    <LineWave
      height={17}
      width={35}
      color={loaderColors[type]}
      ariaLabel='line-wave'
      wrapperStyle={{}}
      wrapperClass=''
      visible={true}
    />
  );

  const isBtnDisabled = isLoading || disabled;
  const renderBtnContent = isLoading ? loader : children;

  return (
    <button
      data-type={type}
      disabled={isBtnDisabled}
      className={clsx([
        'btn',
        type === 'primary' && 'btn-primary',
        className,
        styles.button,
      ])}
      {...otherProps}
    >
      {renderBtnContent}
    </button>
  );
};

Button.defaultProps = {
  className: '',
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Button;
